"use client";

import { useWatchedJobs as useCommonWatchedJobs } from "@repo/design-system/hooks/use-watched-jobs";
import type { SimilarJob as CommonSimilarJob } from "@repo/design-system/types/job";
import type { SimilarJob } from "~/types/job";
function normalizeEonSimilarJob(similarJob: CommonSimilarJob): SimilarJob {
  const postingLanguages = "postingLanguages" in similarJob && Array.isArray(similarJob.postingLanguages) ? similarJob.postingLanguages : ["en"];
  return {
    ...similarJob,
    postingLanguages
  };
}
export function useWatchedJobs() {
  return useCommonWatchedJobs(normalizeEonSimilarJob);
}